export type GuidanceGuideMode = 'Tour' | 'Checklist' | 'Contextual';
export type GuidanceGuideCategory = 'QuickStart' | 'Sales' | 'Catalog' | 'FollowUp' | 'Administration';
export type GuidanceProgressStatus = 'NotStarted' | 'InProgress' | 'Completed' | 'Dismissed';

export interface GuidanceGuideStep {
  id: string;
  title: string;
  body: string;
  targetSelector: string | null;
  actionPath: string | null;
  sortOrder: number;
}

export interface TenantGuidanceGuide {
  id: string;
  title: string;
  description: string;
  category: GuidanceGuideCategory;
  mode: GuidanceGuideMode;
  pagePath: string;
  allowUserSelection: boolean;
  autoSuggest: boolean;
  sortOrder: number;
  steps: GuidanceGuideStep[];
  progressStatus: GuidanceProgressStatus;
  currentStep: number;
  completedAtUtc: string | null;
  dismissedAtUtc: string | null;
}

export interface PlatformGuidanceGuide extends Omit<TenantGuidanceGuide, 'progressStatus' | 'currentStep' | 'completedAtUtc' | 'dismissedAtUtc'> {
  businessTypeCodes: string[];
  requiredPermissionCodes: string[];
  isActive: boolean;
}

export interface SavePlatformGuidanceGuidePayload {
  title: string;
  description: string;
  category: GuidanceGuideCategory;
  mode: GuidanceGuideMode;
  pagePath: string;
  businessTypeCodes: string[];
  requiredPermissionCodes: string[];
  allowUserSelection: boolean;
  autoSuggest: boolean;
  isActive: boolean;
  sortOrder: number;
  steps: Array<Pick<GuidanceGuideStep, 'title' | 'body' | 'targetSelector' | 'actionPath'>>;
}

export const guidanceCategoryLabels: Record<GuidanceGuideCategory, string> = {
  QuickStart: 'شروع سریع',
  Sales: 'فروش',
  Catalog: 'کاتالوگ',
  FollowUp: 'پیگیری',
  Administration: 'مدیریت',
};

export const guidanceModeLabels: Record<GuidanceGuideMode, string> = {
  Tour: 'تور مرحله‌ای',
  Checklist: 'چک‌لیست اجرایی',
  Contextual: 'راهنمای زمینه‌ای',
};
